<!-- Reschedule requests: a decision waiting on the coach comes before anything informational.
     The card stays even with nothing pending, because it is the way into the request history. -->
<div class="agenda-card p-3 mb-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <p class="fs-normal fw-800 color-gray-950 mb-0">
      <i class="bi bi-calendar2-event color-brand-primary me-2"></i>{{'agenda.reschedule_requests'|translate}}
    </p>

    <div class="d-flex align-items-center">
      <span class="badge-pending fs-xsmall fw-800 me-3" *ngIf="rescheduleRequests.length">
        {{'agenda.pending_count'|translate: {count: rescheduleRequests.length} }}
      </span>
      <a class="fs-small fw-800 color-gray-500 clickable" (click)="openAllRequests()">
        {{'agenda.see_all_requests'|translate}}<i class="bi bi-chevron-right ms-1"></i>
      </a>
    </div>
  </div>

  <ngx-skeleton-loader
    *ngIf="rescheduleIsLoading && !rescheduleRequests.length" count="1" appearance="line"
    [theme]="{height: '80px', 'border-radius': '12px', margin: '0'}"/>

  <coach-reschedule-request-row
    class="d-block mb-2" *ngFor="let request of rescheduleRequests"
    [request]="request" [isBusy]="busyRequestId === request.id"
    (approveRequested)="approveReschedule($event)"
    (rejectRequested)="rejectReschedule($event)"></coach-reschedule-request-row>

  <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!rescheduleIsLoading && !rescheduleRequests.length">
    {{'agenda.no_pending_request'|translate}}
  </p>
</div>

<!-- Next meeting -->
<div class="agenda-card next-meeting d-flex flex-column flex-md-row align-items-md-center justify-content-between p-3 mb-3"
     *ngIf="nextAppointment() as next">
  <div class="d-flex align-items-center">
    <span class="next-dot me-3"></span>
    <div>
      <p class="fs-normal fw-800 color-gray-950 mb-0">
        {{'agenda.next_meeting'|translate}}
        <span class="color-brand-primary">{{next.student?.name}}</span>
      </p>
      <p class="fs-small fw-400 color-gray-400 mb-0">
        {{next.startsAt|date:'HH:mm'}} · {{next.title}}
      </p>
    </div>
  </div>

  <div class="mt-3 mt-md-0">
    <app-gray-button
      *ngIf="next.meetLink" color="primary" [fullWidth]="false" padding="px-4 py-2"
      preIcon="videos" [text]="'agenda.join_meeting'|translate"
      (click)="openMeetLink(next)"></app-gray-button>
    <p class="fs-small color-gray-400 mb-0" *ngIf="!next.meetLink">{{'agenda.no_meet_link'|translate}}</p>
  </div>
</div>

<!-- Tabs -->
<div class="tab-switch d-inline-flex p-1 mb-3">
  <a class="tab-item fs-small fw-800 clickable" [class.active]="activeTab === 'today'" (click)="activeTab = 'today'">
    {{'agenda.today_plan'|translate}}
  </a>
  <a class="tab-item fs-small fw-800 clickable" [class.active]="activeTab === 'calendar'" (click)="activeTab = 'calendar'">
    {{'agenda.calendar_view'|translate}}
  </a>
</div>

<coach-agenda-today
  *ngIf="activeTab === 'today'"
  [rescheduleRequests]="rescheduleRequests" [refreshToken]="dayRefreshToken"></coach-agenda-today>

<ng-container *ngIf="activeTab === 'calendar'">

  <div class="agenda-card p-3 p-md-4 mb-3">
    <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">

      <div class="d-flex align-items-center">
        <a class="range-nav clickable me-2" (click)="moveRange(-1)"><i class="bi bi-chevron-left"></i></a>
        <a class="range-nav clickable me-3" (click)="moveRange(1)"><i class="bi bi-chevron-right"></i></a>
        <div>
          <p class="fs-xsmall fw-800 color-brand-primary mb-0">{{rangeLabel()}}</p>
          <p class="fs-20 fw-800 color-gray-950 mb-0">
            {{(view === 'week' ? 'agenda.weekly_title' : 'agenda.monthly_title')|translate}}
          </p>
        </div>
      </div>

      <div class="d-flex align-items-center mt-3 mt-lg-0">
        <app-gray-button
          color="stroke" [fullWidth]="false" padding="p-1" [weight]="500"
          customClass="header-btn fs-small me-2"
          [text]="'agenda.today'|translate" (click)="goToToday()"></app-gray-button>

        <app-gray-button
          color="stroke" [fullWidth]="false" padding="p-1" [weight]="500"
          customClass="header-btn fs-small me-3 d-none d-md-inline-flex"
          preIcon="calendar" [text]="'agenda.manage_availability'|translate"
          (click)="openAvailability()"></app-gray-button>

        <div class="view-switch d-inline-flex p-1 me-3">
          <a class="tab-item fs-small fw-800 clickable" [class.active]="view === 'week'" (click)="setView('week')">
            {{'agenda.weekly'|translate}}
          </a>
          <a class="tab-item fs-small fw-800 clickable" [class.active]="view === 'month'" (click)="setView('month')">
            {{'agenda.monthly'|translate}}
          </a>
        </div>

        <div class="text-end">
          <p class="fs-20 fw-800 color-brand-primary mb-0">{{scheduledCount()}}</p>
          <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{'agenda.planned_meetings'|translate}}</p>
        </div>
      </div>

    </div>
  </div>

  <!-- The grid cannot be drawn before the availability and the settings are in. -->
  <ngx-skeleton-loader
    *ngIf="baseIsLoading" count="1" appearance="line"
    [theme]="{height: '420px', 'border-radius': '16px', margin: '0'}"/>

  <!-- Availability is what the grid is built from, so an empty one blocks everything else -->
  <div class="agenda-card p-5 text-center" *ngIf="!hasAvailability() && !isLoading && !baseIsLoading">
    <p class="fs-normal fw-800 color-gray-950 mb-2">{{'agenda.no_availability_title'|translate}}</p>
    <p class="fs-small fw-400 color-gray-400 mb-4">{{'agenda.no_availability_desc'|translate}}</p>
    <app-gray-button
      color="primary" [fullWidth]="false" padding="px-4 py-2"
      [text]="'agenda.manage_availability'|translate" (click)="openAvailability()"></app-gray-button>
  </div>

  <ng-container *ngIf="hasAvailability() && !baseIsLoading">
    <coach-agenda-week
      *ngIf="view === 'week'"
      [weekStart]="rangeStart" [appointments]="appointments" [availability]="availability"
      [settings]="settings" [preselectedStudentId]="preselectedStudentId" (changed)="getAppointments()"
      (availabilityRequested)="openAvailability()"></coach-agenda-week>

    <coach-agenda-month
      *ngIf="view === 'month'"
      [monthStart]="rangeStart" [appointments]="appointments"
      (daySelected)="openWeekOf($event)"></coach-agenda-month>
  </ng-container>

</ng-container>
